import React, { Component } from "react";
import { closeIcon } from "../../../utils/images";
import commonContext, { AppContext } from "../../../context/common";
import { leadType } from "../../../../app";
import { ALDDApis } from "../../../../ddAl/apis/aLDDApis";
import InputForm from "../../html/inputForm";

interface IProps {
    onclickhandler: Function;
}
interface IState {
    ifscSearch?: string;
    branchNameSearch?: string;
    ifscSelect?: string;
    micrCodeSelect?: string;
    branchNameSelect?: string;
}
export class IfscPopUp extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    setLeadError: Function;
    apis: ALDDApis;
    constructor(props: IProps) {
        super(props);
        this.state = {
            ifscSearch: "",
            branchNameSearch: "",
            ifscSelect: null,
        };
    }
    async componentDidMount() {
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.setState({
            ifscSearch: this.lead.ifsc,
            branchNameSearch: this.lead.bankBranchName,
        });
    }
    handleOnSubmitSearch = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.getIMPSDetails({
            ...this.lead,
            bank: this.lead.bankName,
            ifsc: this.state.ifscSearch,
            branch: this.state.branchNameSearch,
        });
        if (apiData.error?.error) {
            // error
        } else {
            this.setLead({
                ...apiData.result,
            });
        }
    };
    handleOnSubmitIFSC = (e) => {
        e.preventDefault();
        if (this.state.ifscSelect) {
            this.setLead({
                ifsc: this.state.ifscSelect,
                micrCode: this.state.micrCodeSelect,
                bankBranchName: this.state.branchNameSelect,
            });
            this.props.onclickhandler();
            this.setLeadError({ ifsc: "" });
        } else {
            //error
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div
                    className="modal fixed w-full h-full top-0 left-0 flex justify-center items-center z-50"
                    id="ifscModal"
                >
                    <div
                        className="modal-overlay absolute w-full h-full bg-black opacity-50"
                        onClick={() => this.props.onclickhandler()}
                    ></div>
                    <div className="modal-container bg-white w-11/12 sm:w-6/12 lg:w-5/12 mx-auto rounded shadow-lg z-50 overflow-y-auto mb-2 sm:mb-0">
                        <div className="modal-content  text-left py-2 px-2 md:py-3 md:px-3 lg:py-6 lg:px-6">
                            <div
                                className="w-full modal-close cursor-pointer z-50 float-right"
                                onClick={() => this.props.onclickhandler()}
                            >
                                <img
                                    src={closeIcon}
                                    title="Close"
                                    alt="Close"
                                />
                            </div>
                            <div className="w-full mt-8 mx-auto">
                                <h2 className="openSans-Light text-black mt-3 mb-3 text-2xl md:text-3xl lg:text-3xl xl:text-4xl">
                                    IFSC Code Lookup
                                </h2>

                                <div className="mainifscScroll">
                                    <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                        <div className="w-full my-2">
                                            <div className="flex flex-wrap -mx-2">
                                                <div className="w-full relative lg:w-4/12 px-2 mb-0 md:mb-4">
                                                    <InputForm
                                                        label="Bank Name"
                                                        errorText="Please enter bank name"
                                                        name="bankName"
                                                        value={
                                                            this.lead.bankName
                                                        }
                                                        readonly={true}
                                                    />
                                                </div>
                                                <div className="w-full relative lg:w-4/12 px-2 mb-0 md:mb-4">
                                                    <InputForm
                                                        label="IFSC code"
                                                        errorText="Please enter IFSC code"
                                                        name="ifscSearch"
                                                        value={
                                                            this.state
                                                                .ifscSearch
                                                        }
                                                        handlerOnChange={(e) =>
                                                            this.setState({
                                                                ifscSearch:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="w-full relative lg:w-4/12 px-2 mb-0 md:mb-4">
                                                    <InputForm
                                                        label="Branch Name"
                                                        errorText="Please enter branch name"
                                                        name="branchNameSerach"
                                                        value={
                                                            this.state
                                                                .branchNameSearch
                                                        }
                                                        handlerOnChange={(e) =>
                                                            this.setState({
                                                                branchNameSearch:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="w-full sm:w-8/12 mx-auto my-4 flex flex-wrap justify-around">
                                                    <div className="relative w-5/12 mx-auto text-center">
                                                        <button
                                                            className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 border-2 button-blue-border"
                                                            title="Ok"
                                                            onClick={(e) =>
                                                                this.handleOnSubmitSearch(
                                                                    e
                                                                )
                                                            }
                                                        >
                                                            Ok
                                                        </button>
                                                    </div>
                                                    <div className="relative w-5/12 mx-auto text-center">
                                                        <button
                                                            type="reset"
                                                            className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                            title="Clear"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({
                                                                    ifscSearch:
                                                                        "",
                                                                    branchNameSearch:
                                                                        "",
                                                                });
                                                            }}
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-full ifsc-code-table-wrap">
                                                <table className="w-full flex flex-col flex-wrap bg-white text-sm openSans-Reg ifsc-code-table">
                                                    <thead className="w-full flex flex-col flex-wrap">
                                                        <tr className="w-full flex flex-row flex-wrap lighter-blue-2 text-black text-center">
                                                            <th className="px-1 md:px-2 py-3 md:py-2 w-3/12 border-grey-light border">
                                                                Select
                                                            </th>
                                                            <th className="px-1 md:px-2 py-3 md:py-2 w-3/12 border-grey-light border">
                                                                Bank
                                                            </th>
                                                            <th className="px-1 md:px-2 py-3 md:py-2 w-3/12 border-grey-light border">
                                                                Branch
                                                            </th>
                                                            <th className="px-1 md:px-2 py-3 md:py-2 w-3/12 border-grey-light border">
                                                                IFSC
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="w-full">
                                                        {this.lead.imps.map(
                                                            (
                                                                item: {
                                                                    ifsc: string;
                                                                    branch: string;
                                                                    micrCode: string;
                                                                },
                                                                index
                                                            ) => {
                                                                return (
                                                                    <tr className="w-full flex flex-row flex-wrap hover:bg-gray-100 text-center">
                                                                        <td className="w-3/12 border-grey-light border px-1 md:px-2 py-3 md:py-2">
                                                                            <div className="custom-inputs">
                                                                                <label className="inline-flex items-center">
                                                                                    <input
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                        type="radio"
                                                                                        name="ifsc-select"
                                                                                        value={
                                                                                            item.ifsc
                                                                                        }
                                                                                        onChange={() =>
                                                                                            this.setState(
                                                                                                {
                                                                                                    ifscSelect:
                                                                                                        item.ifsc,
                                                                                                    micrCodeSelect:
                                                                                                        item.micrCode,
                                                                                                    branchNameSelect:
                                                                                                        item.branch,
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                    <span></span>
                                                                                </label>
                                                                            </div>
                                                                        </td>
                                                                        <td className="w-3/12 border-grey-light border px-1 md:px-2 py-3 md:py-2">
                                                                            {
                                                                                this
                                                                                    .lead
                                                                                    .bankName
                                                                            }
                                                                        </td>
                                                                        <td className="w-3/12 border-grey-light border px-1 md:px-2 py-3 md:py-2">
                                                                            {
                                                                                item.branch
                                                                            }
                                                                        </td>
                                                                        <td className="w-3/12 border-grey-light border px-1 md:px-2 py-3 md:py-2">
                                                                            {
                                                                                item.ifsc
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full flex flex-wrap pt-3 text-center justify-center">
                                    <div className="relative w-full sm:w-4/12 mx-auto text-center">
                                        <button
                                            className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 border-2 button-blue-border"
                                            title="Confirm"
                                            onClick={(e) =>
                                                this.handleOnSubmitIFSC(e)
                                            }
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default IfscPopUp;
